var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{expired: _vm.expired},staticStyle:{"display":"inline-block"}},[_c('v-icon',[_vm._v("mdi-clock-outline")]),_vm._v(" "+_vm._s(_vm.expired ? '+ ' : '')+_vm._s(_vm.remainingAbsTime?.toString())+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }